﻿export interface OpinionSignRecord {
  id: string;
  applyNo: string;
  planNo: string;
  applyName: string;
  projectType: string;
  isBenefit: boolean;
  createDate: string;
  status: string;
  buildUnit: string;
  handler: string;
  applicant: string;
  currentSituation: string;
  mainScheme: string;
  mainDevice: string;
  water: string;
  electricity: string;
  gas: string;
  oxygen: string;
  otherAux: string;
  techTarget: string;
  benefitEffect: string;
  otherTarget: string;
  personnelChange: string;
  innovation: string;
  energyAssess: string;
  applyDuration: string;
  suggestDuration: string;
  riskOpportunity: string;
  relatedOpinion: string;
  planAmount: number;
  declareAmount: number;
  suggestAmount: number;
  costComposition: string;
  removeUpdateCost: number;
  conclusion: string;
  orgUnit: string;
  argumentDate: string;
  attendees: string;
  meetingLocation: string;
  committeeDate: string;
  committeeAttendees: string;
  committeeStatus: string;
  attachments: { name: string; size: number; url: string }[];
}

export const opinionSignStatuses = [
  { value: '草稿', label: '草稿', color: 'bg-slate-100 text-slate-600' },
  { value: '待签署', label: '待签署', color: 'bg-sky-50 text-sky-700 border border-sky-200' },
  { value: '已签署', label: '已签署', color: 'bg-blue-50 text-blue-700 border border-blue-200' },
  { value: '待呈核', label: '待呈核', color: 'bg-amber-50 text-amber-700 border border-amber-200' },
  { value: '审批中', label: '审批中', color: 'bg-amber-50 text-amber-700 border border-amber-200' },
  { value: '待确认', label: '待确认', color: 'bg-orange-50 text-orange-700 border border-orange-200' },
  { value: '已确认', label: '已确认', color: 'bg-green-50 text-green-700 border border-green-200' },
  { value: '待全委会', label: '待全委会', color: 'bg-violet-50 text-violet-700 border border-violet-200' },
  { value: '全委会审批中', label: '全委会审批中', color: 'bg-purple-50 text-purple-700 border border-purple-200' },
];

export const opinionSignProjectTypes = [
  '大型新建',
  '技改',
  '年修',
  '零星',
  '搬迁',
  '备件修复',
  '其他',
];

export const opinionSignBuildUnits = [
  '第一炼铁事业部',
  '第二炼铁事业部',
  '炼钢事业部',
  '板材事业部',
  '特钢事业部',
  '能源动力事业部',
  '物流中心',
  '安全环保处',
  '设备管理部',
];

export const opinionSignHandlers = [
  '张明远',
  '李建国',
  '王志强',
  '陈海燕',
  '赵卫东',
  '刘爱国',
  '孙红梅',
  '周国强',
  '黄秀英',
  '徐伟明',
  '胡春兰',
  '朱志华',
  '林冬梅',
  '何永强',
  '吴慧芳',
  '谢建国',
  '马小燕',
  '孙志强',
];

export const opinionSignRecords: OpinionSignRecord[] = [
  {
    id: 'os-001',
    applyNo: 'LZ-2026-05201',
    planNo: 'PL-2026-01203',
    applyName: '第一炼铁事业部3号高炉热风炉换管改造项目论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-04-28',
    status: '待签署',
    buildUnit: '第一炼铁事业部',
    handler: '张明远',
    applicant: '李建国',
    currentSituation: '3号高炉热风炉投运已12年，部分炉管存在老化腐蚀现象，需要更新换管',
    mainScheme: '对3号高炉热风炉炉管进行逐段检测，更换腐蚀老化炉管约180米',
    mainDevice: '热风炉炉管系统、耐材、检测仪器等',
    water: '施工期间临时用水约200吨',
    electricity: '新增施工临时用电约150kW',
    gas: '不影响原有煤气管线',
    oxygen: '不影响原有氧气供应',
    otherAux: '需配套临时通风设备',
    techTarget: '热风炉效率提升3-5%，减少煤气消耗',
    benefitEffect: '预计年节约煤气费用约85万元',
    otherTarget: '同步消除安全隐患，提升安全生产水平',
    personnelChange: '无变动',
    innovation: '引入新型耐材技术，延长炉管寿命',
    energyAssess: '热风炉效率提升后预计年节约标准煤约120吨',
    applyDuration: '2026-07-01',
    suggestDuration: '2026-09-15',
    riskOpportunity: '风险：施工期间需停炉，影响生产；机遇：提升设备可靠性和安全性',
    relatedOpinion: '需协调生产计划，安排合理施工窗口',
    planAmount: 320,
    declareAmount: 350,
    suggestAmount: 338,
    costComposition: '炉管材料费180万、施工费85万、耐材费45万、检测费28万',
    removeUpdateCost: 15,
    conclusion: '经论证认为该项目技术改造可行，建议按计划实施',
    orgUnit: '总师室',
    argumentDate: '2026-04-20',
    attendees: '张明远、李建国、王志强、陈海燕',
    meetingLocation: '技术中心会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
  {
    id: 'os-002',
    applyNo: 'LZ-2026-05202',
    planNo: 'PL-2026-01205',
    applyName: '炼钢事业部转炉二次除尘系统改造论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-04-25',
    status: '已签署',
    buildUnit: '炼钢事业部',
    handler: '王志强',
    applicant: '赵卫东',
    currentSituation: '现有二次除尘系统能力不足，粉尘排放超标，亟需升级改造',
    mainScheme: '新增高效布袋除尘器2套，配套风机系统更新，烟气管道优化',
    mainDevice: '布袋除尘器、离心风机、管道及阀门等',
    water: '新增除尘系统用水约50吨/月',
    electricity: '新增用电量约280kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需新建除尘间约300平米',
    techTarget: '粉尘排放浓度≤10mg/m³，满足超低排放要求',
    benefitEffect: '消除环保风险，避免罚款；提升现场作业环境',
    otherTarget: '满足超低排放要求，提升环保管理水平',
    personnelChange: '新增除尘运维人员2名',
    innovation: '采用智能变频控制技术，降低能耗',
    energyAssess: '风机采用变频控制后预计节电20%',
    applyDuration: '2026-06-15',
    suggestDuration: '2026-09-30',
    riskOpportunity: '风险：施工期间需协调生产与环保要求；机遇：提升环保合规性',
    relatedOpinion: '需提前向环保部门报备，协调施工窗口',
    planAmount: 580,
    declareAmount: 620,
    suggestAmount: 600,
    costComposition: '除尘设备费420万、施工安装费120万、电气改造费60万',
    removeUpdateCost: 20,
    conclusion: '环保改造项目优先实施，建议按计划推进',
    orgUnit: '安全环保处',
    argumentDate: '2026-04-18',
    attendees: '王志强、赵卫东、孙红梅、周国强',
    meetingLocation: '炼钢事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [{ name: '论证意见_转炉除尘改造.docx', size: 128000, url: '#' }],
  },
  {
    id: 'os-003',
    applyNo: 'LZ-2026-05203',
    planNo: 'PL-2026-01208',
    applyName: '板材事业部宽厚板精整线自动化升级论证意见签署',
    projectType: '大型新建',
    isBenefit: true,
    createDate: '2026-04-22',
    status: '待呈核',
    buildUnit: '板材事业部',
    handler: '陈海燕',
    applicant: '黄秀英',
    currentSituation: '宽厚板精整线自动化程度低，人工操作多，效率受限',
    mainScheme: '对精整线进行自动化升级，新增智能剪切、自动堆垛、AGV运输等系统',
    mainDevice: '智能剪切机、自动堆垛机、AGV运输系统、MES接口等',
    water: '不涉及',
    electricity: '新增用电量约500kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套网络及控制室改造',
    techTarget: '精整线自动化率提升至85%以上',
    benefitEffect: '预计年节约人工成本约180万元，提升产能10%',
    otherTarget: '提升智能化水平，降低安全风险',
    personnelChange: '减少精整线操作工8名，新增自动化运维人员4名',
    innovation: '引入智能视觉识别和AI优化算法',
    energyAssess: '自动化后设备协同优化，预计整体能耗降低5%',
    applyDuration: '2026-05-01',
    suggestDuration: '2026-11-30',
    riskOpportunity: '风险：系统调试周期长；机遇：提升自动化水平和竞争力',
    relatedOpinion: '建议分阶段实施，降低一次性投入风险',
    planAmount: 1250,
    declareAmount: 1380,
    suggestAmount: 1320,
    costComposition: '设备采购费980万、施工安装费180万、软件开发费90万、调试费50万',
    removeUpdateCost: 35,
    conclusion: '自动化升级项目技术方案可行，建议按计划实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-04-15',
    attendees: '陈海燕、黄秀英、徐伟明、胡春兰',
    meetingLocation: '技术中心大会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [{ name: '自动化升级方案.pdf', size: 2560000, url: '#' }, { name: '投资估算表.xlsx', size: 45000, url: '#' }],
  },
  {
    id: 'os-004',
    applyNo: 'LZ-2026-05204',
    planNo: 'PL-2026-01210',
    applyName: '特钢事业部电炉除尘超低排放改造论证意见签署',
    projectType: '技改',
    isBenefit: false,
    createDate: '2026-04-20',
    status: '待确认',
    buildUnit: '特钢事业部',
    handler: '刘爱国',
    applicant: '孙志强',
    currentSituation: '现有电炉除尘系统无法满足超低排放新要求，需要升级改造',
    mainScheme: '对现有除尘系统进行全面升级改造，新增高效除尘设备',
    mainDevice: '高效布袋除尘器、变频风机、智能控制系统',
    water: '新增用水约80吨/月',
    electricity: '新增用电量约200kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需新建约400平米除尘设备基础',
    techTarget: '实现超低排放标准，粉尘排放≤10mg/m³',
    benefitEffect: '消除环保风险，满足超低排放要求',
    otherTarget: '提升环保管理水平，减少粉尘对周边环境影响',
    personnelChange: '新增环保运维人员2名',
    innovation: '采用智能监测联动控制系统',
    energyAssess: '变频风机预计节电15%',
    applyDuration: '2026-08-01',
    suggestDuration: '2026-12-31',
    riskOpportunity: '风险：施工期间需协调生产；机遇：满足环保法规要求',
    relatedOpinion: '建议申请环保专项资金支持',
    planAmount: 420,
    declareAmount: 460,
    suggestAmount: 440,
    costComposition: '除尘设备费300万、土建施工费60万、电气改造费60万、安装调试费40万',
    removeUpdateCost: 12,
    conclusion: '环保改造项目必要且紧急，建议尽快实施',
    orgUnit: '安全环保处',
    argumentDate: '2026-04-12',
    attendees: '刘爱国、孙志强、林冬梅、何永强',
    meetingLocation: '特钢事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [{ name: '超低排放方案.pdf', size: 1890000, url: '#' }],
  },
  {
    id: 'os-005',
    applyNo: 'LZ-2026-05205',
    planNo: 'PL-2026-01212',
    applyName: '能源动力事业部余热发电系统扩建论证意见签署',
    projectType: '大型新建',
    isBenefit: true,
    createDate: '2026-04-18',
    status: '已确认',
    buildUnit: '能源动力事业部',
    handler: '孙红梅',
    applicant: '吴慧芳',
    currentSituation: '现有余热发电能力无法满足新增产能的能源回收需求',
    mainScheme: '新增余热锅炉2套、汽轮机1台及配套电气系统',
    mainDevice: '余热锅炉、汽轮机、发电机、电气开关柜等',
    water: '新增循环水系统，约500吨/小时',
    electricity: '新增发电量约6MW',
    gas: '新增高炉煤气回收管道',
    oxygen: '不涉及',
    otherAux: '需配套冷却水塔和化水系统',
    techTarget: '新增余热发电能力约6MW，年发电量约4200万度',
    benefitEffect: '预计年节约外购电费约2100万元',
    otherTarget: '提升能源利用效率，降低碳排放',
    personnelChange: '新增发电运维人员6名',
    innovation: '采用新型高效余热锅炉技术',
    energyAssess: '余热利用率从35%提升至42%',
    applyDuration: '2026-07-15',
    suggestDuration: '2027-03-31',
    riskOpportunity: '风险：投资回收期较长；机遇：能源自给率提升，长期收益显著',
    relatedOpinion: '建议同步申请绿色能源项目补贴',
    planAmount: 2800,
    declareAmount: 3100,
    suggestAmount: 2950,
    costComposition: '锅炉设备费1200万、汽轮机800万、电气系统500万、土建安装费300万',
    removeUpdateCost: 80,
    conclusion: '余热发电扩建项目技术成熟，投资回收期约3.5年，建议实施',
    orgUnit: '能源动力事业部',
    argumentDate: '2026-04-10',
    attendees: '孙红梅、吴慧芳、谢建国、马小燕',
    meetingLocation: '能源动力事业部会议室',
    committeeDate: '2026-04-25',
    committeeAttendees: '公司领导、事业部负责人、总师室、安全环保处',
    committeeStatus: '待召开',
    attachments: [{ name: '余热发电方案.pdf', size: 3200000, url: '#' }],
  },
  {
    id: 'os-006',
    applyNo: 'LZ-2026-05206',
    planNo: 'PL-2026-01215',
    applyName: '物流中心堆取料机智能化改造论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-04-15',
    status: '审批中',
    buildUnit: '物流中心',
    handler: '赵卫东',
    applicant: '朱志华',
    currentSituation: '现有堆取料机人工操作，效率低且存在安全隐患',
    mainScheme: '对堆取料机进行智能化改造，增加自动定位、远程操控系统',
    mainDevice: '智能定位系统、远程操控台、视频监控系统',
    water: '不涉及',
    electricity: '新增用电量约80kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套网络及控制室改造',
    techTarget: '实现堆取料机远程自动作业，减少人工干预',
    benefitEffect: '预计减少操作人员4名，提升作业效率25%',
    otherTarget: '消除现场作业安全隐患',
    personnelChange: '减少现场操作工4名，新增中控室操作员2名',
    innovation: '采用激光扫描定位技术',
    energyAssess: '优化作业路径后预计节电8%',
    applyDuration: '2026-09-01',
    suggestDuration: '2026-12-15',
    riskOpportunity: '风险：新系统稳定性需验证；机遇：大幅提升作业效率和安全性',
    relatedOpinion: '建议先做一台试点改造，验证后推广',
    planAmount: 180,
    declareAmount: 200,
    suggestAmount: 190,
    costComposition: '智能定位系统80万、远程操控系统50万、视频监控30万、安装调试20万',
    removeUpdateCost: 5,
    conclusion: '智能化改造方案技术可行，建议先试点后推广',
    orgUnit: '设备管理部',
    argumentDate: '2026-04-08',
    attendees: '赵卫东、朱志华、林冬梅、何永强',
    meetingLocation: '物流中心会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
  {
    id: 'os-007',
    applyNo: 'LZ-2026-05207',
    planNo: 'PL-2026-01218',
    applyName: '第二炼铁事业部高炉出铁场除尘优化论证意见签署',
    projectType: '技改',
    isBenefit: false,
    createDate: '2026-04-12',
    status: '草稿',
    buildUnit: '第二炼铁事业部',
    handler: '周国强',
    applicant: '徐伟明',
    currentSituation: '出铁场除尘效果不佳，作业环境粉尘浓度超标',
    mainScheme: '优化除尘罩口设计，新增侧吸罩，升级风机系统',
    mainDevice: '除尘罩、侧吸罩、高效风机、管道',
    water: '不涉及',
    electricity: '新增用电量约150kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套除尘器升级',
    techTarget: '出铁场粉尘浓度≤8mg/m³',
    benefitEffect: '改善作业环境，消除职业健康风险',
    otherTarget: '满足职业健康防护要求',
    personnelChange: '无变动',
    innovation: '采用新型除尘罩口气流优化设计',
    energyAssess: '风机效率提升后预计节电10%',
    applyDuration: '2026-10-01',
    suggestDuration: '2027-01-31',
    riskOpportunity: '风险：施工期间影响出铁作业；机遇：改善工作环境',
    relatedOpinion: '建议与年修同步实施',
    planAmount: 260,
    declareAmount: 290,
    suggestAmount: 275,
    costComposition: '除尘设备费160万、施工安装费60万、电气改造费40万、调试费35万',
    removeUpdateCost: 8,
    conclusion: '建议与年修同步实施，减少停机影响',
    orgUnit: '安全环保处',
    argumentDate: '',
    attendees: '',
    meetingLocation: '',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
  {
    id: 'os-008',
    applyNo: 'LZ-2026-05208',
    planNo: 'PL-2026-01220',
    applyName: '炼钢事业部连铸机二冷区智能控制改造论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-04-10',
    status: '待全委会',
    buildUnit: '炼钢事业部',
    handler: '黄秀英',
    applicant: '胡春兰',
    currentSituation: '连铸机二冷区水量控制依赖人工经验，铸坯质量波动大',
    mainScheme: '引入智能水量控制系统，根据钢种和拉速自动调节二冷水量',
    mainDevice: '智能流量控制阀、在线测温系统、PLC控制系统',
    water: '优化用水后预计节水10%',
    electricity: '新增用电量约60kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套网络及服务器',
    techTarget: '铸坯表面质量合格率提升至98%以上',
    benefitEffect: '减少质量异议损失约120万元/年',
    otherTarget: '提升铸坯质量稳定性',
    personnelChange: '无变动',
    innovation: '采用AI算法优化二冷配水模型',
    energyAssess: '优化配水后节水节能',
    applyDuration: '2026-08-15',
    suggestDuration: '2026-12-31',
    riskOpportunity: '风险：新控制系统调试复杂；机遇：大幅提升产品质量',
    relatedOpinion: '建议先做中间包区域试点',
    planAmount: 220,
    declareAmount: 250,
    suggestAmount: 235,
    costComposition: '控制系统费120万、流量阀组50万、测温系统30万、安装调试20万',
    removeUpdateCost: 6,
    conclusion: '智能控制改造技术先进，建议实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-04-05',
    attendees: '黄秀英、胡春兰、谢建国、马小燕',
    meetingLocation: '炼钢事业部会议室',
    committeeDate: '2026-05-05',
    committeeAttendees: '公司领导、事业部负责人、总师室、安全环保处',
    committeeStatus: '待召开',
    attachments: [{ name: '智能控制方案.pdf', size: 980000, url: '#' }],
  },
  {
    id: 'os-009',
    applyNo: 'LZ-2026-05209',
    planNo: 'PL-2026-01225',
    applyName: '板材事业部加热炉节能改造论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-04-08',
    status: '全委会审批中',
    buildUnit: '板材事业部',
    handler: '何永强',
    applicant: '林冬梅',
    currentSituation: '加热炉热效率偏低，煤气消耗量大，需要节能改造',
    mainScheme: '采用蓄热式燃烧技术，更换高效烧嘴，优化炉体保温',
    mainDevice: '蓄热式烧嘴、蓄热体、高效保温材料',
    water: '不涉及',
    electricity: '新增用电量约40kW',
    gas: '优化后预计节煤气15%',
    oxygen: '不涉及',
    otherAux: '需配套炉体局部改造',
    techTarget: '加热炉热效率提升至65%以上',
    benefitEffect: '预计年节约煤气费用约350万元',
    otherTarget: '降低碳排放，提升环保绩效',
    personnelChange: '无变动',
    innovation: '采用新型蓄热材料，提升蓄热效率',
    energyAssess: '热效率从52%提升至65%，年节约标准煤约800吨',
    applyDuration: '2026-07-01',
    suggestDuration: '2026-10-31',
    riskOpportunity: '风险：改造期间需停炉；机遇：长期节能效益显著',
    relatedOpinion: '建议与年修同步实施',
    planAmount: 380,
    declareAmount: 420,
    suggestAmount: 400,
    costComposition: '烧嘴设备费200万、蓄热体80万、保温材料60万、施工安装费40万',
    removeUpdateCost: 10,
    conclusion: '节能改造项目效益显著，回收期约1.5年，建议实施',
    orgUnit: '能源动力事业部',
    argumentDate: '2026-04-02',
    attendees: '何永强、林冬梅、谢建国、马小燕',
    meetingLocation: '板材事业部会议室',
    committeeDate: '2026-04-20',
    committeeAttendees: '公司领导、事业部负责人、总师室、安全环保处',
    committeeStatus: '审批中',
    attachments: [{ name: '节能改造方案.pdf', size: 1450000, url: '#' }, { name: '投资回收测算.xlsx', size: 38000, url: '#' }],
  },
  {
    id: 'os-010',
    applyNo: 'LZ-2026-05210',
    planNo: 'PL-2026-01228',
    applyName: '安全环保处废水处理系统升级论证意见签署',
    projectType: '技改',
    isBenefit: false,
    createDate: '2026-04-05',
    status: '已确认',
    buildUnit: '安全环保处',
    handler: '马小燕',
    applicant: '吴慧芳',
    currentSituation: '现有废水处理能力不足，无法满足新增产能的废水处理需求',
    mainScheme: '新增废水处理设施，升级现有处理工艺',
    mainDevice: '高效沉淀池、过滤系统、消毒设备',
    water: '新增处理能力500吨/天',
    electricity: '新增用电量约180kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套管网改造',
    techTarget: '废水处理达标率100%，满足最新排放标准',
    benefitEffect: '消除环保风险，满足排放要求',
    otherTarget: '提升环保管理水平',
    personnelChange: '新增废水处理运维人员3名',
    innovation: '采用新型高效沉淀技术',
    energyAssess: '优化工艺后处理能耗降低8%',
    applyDuration: '2026-09-01',
    suggestDuration: '2027-02-28',
    riskOpportunity: '风险：施工期间需协调现有系统运行；机遇：提升环保合规性',
    relatedOpinion: '建议申请环保专项资金',
    planAmount: 450,
    declareAmount: 500,
    suggestAmount: 480,
    costComposition: '处理设备费300万、土建施工费100万、电气安装费50万、调试费30万',
    removeUpdateCost: 15,
    conclusion: '环保升级项目必要且紧急，建议尽快实施',
    orgUnit: '安全环保处',
    argumentDate: '2026-03-28',
    attendees: '马小燕、吴慧芳、谢建国、孙志强',
    meetingLocation: '安全环保处会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [{ name: '废水处理方案.pdf', size: 2100000, url: '#' }],
  },
  {
    id: 'os-011',
    applyNo: 'LZ-2026-05211',
    planNo: 'PL-2026-01230',
    applyName: '特钢事业部VD真空精炼系统改造论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-04-03',
    status: '待签署',
    buildUnit: '特钢事业部',
    handler: '谢建国',
    applicant: '何永强',
    currentSituation: '现有VD系统抽气能力不足，影响特钢产品质量和生产效率',
    mainScheme: '更换更大抽气能力的真空泵组，优化真空管道系统',
    mainDevice: '真空泵组、真空管道、阀门、控制系统',
    water: '新增冷却水用量约100吨/小时',
    electricity: '新增用电量约350kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套真空罐改造',
    techTarget: '真空度提升至0.1mbar以下，精炼周期缩短15%',
    benefitEffect: '提升产品质量，减少质量异议约80万元/年',
    otherTarget: '提升特钢产品竞争力',
    personnelChange: '无变动',
    innovation: '采用新型干式真空泵技术',
    energyAssess: '新泵组效率更高，预计节电12%',
    applyDuration: '2026-08-01',
    suggestDuration: '2026-12-15',
    riskOpportunity: '风险：改造期间影响特钢生产；机遇：提升产品质量',
    relatedOpinion: '建议安排合理施工窗口',
    planAmount: 520,
    declareAmount: 580,
    suggestAmount: 550,
    costComposition: '真空泵组300万、管道阀门120万、控制系统60万、安装调试40万',
    removeUpdateCost: 18,
    conclusion: 'VD系统改造对特钢产品质量提升至关重要，建议实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-03-25',
    attendees: '谢建国、何永强、孙志强、吴慧芳',
    meetingLocation: '特钢事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
  {
    id: 'os-012',
    applyNo: 'LZ-2026-05212',
    planNo: 'PL-2026-01233',
    applyName: '第一炼铁事业部喷煤系统智能化升级论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-04-01',
    status: '已签署',
    buildUnit: '第一炼铁事业部',
    handler: '孙志强',
    applicant: '马小燕',
    currentSituation: '喷煤系统人工配煤，煤比波动大，影响高炉操作稳定性',
    mainScheme: '引入智能配煤系统，根据高炉工况自动调节喷煤量',
    mainDevice: '智能配煤控制器、在线煤质分析仪、执行机构',
    water: '不涉及',
    electricity: '新增用电量约50kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套控制室升级',
    techTarget: '煤比稳定率提升至95%以上',
    benefitEffect: '预计年节约焦炭费用约200万元',
    otherTarget: '提升高炉操作稳定性',
    personnelChange: '减少配煤工3名',
    innovation: '采用在线煤质快速分析技术',
    energyAssess: '优化配煤后预计节煤5%',
    applyDuration: '2026-07-15',
    suggestDuration: '2026-11-30',
    riskOpportunity: '风险：新系统需调试适应；机遇：大幅提升操作稳定性',
    relatedOpinion: '建议先做一台高炉试点',
    planAmount: 160,
    declareAmount: 180,
    suggestAmount: 170,
    costComposition: '智能控制器80万、分析仪40万、执行机构25万、安装调试15万',
    removeUpdateCost: 4,
    conclusion: '智能化升级方案技术可行，建议先试点后推广',
    orgUnit: '设备管理部',
    argumentDate: '2026-03-22',
    attendees: '孙志强、马小燕、谢建国、林冬梅',
    meetingLocation: '第一炼铁事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [{ name: '喷煤智能化方案.pdf', size: 870000, url: '#' }],
  },
  {
    id: 'os-013',
    applyNo: 'LZ-2026-05213',
    planNo: 'PL-2026-01236',
    applyName: '炼钢事业部LF精炼炉电极智能调节改造论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-03-28',
    status: '待呈核',
    buildUnit: '炼钢事业部',
    handler: '吴慧芳',
    applicant: '谢建国',
    currentSituation: 'LF炉电极调节依赖人工，弧流控制不精准，电极消耗大',
    mainScheme: '引入智能电极调节系统，实时优化弧长控制',
    mainDevice: '智能调节控制器、高精度传感器、执行机构',
    water: '不涉及',
    electricity: '优化后预计节电10%',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套控制系统升级',
    techTarget: '电极消耗降低15%，电耗降低10%',
    benefitEffect: '预计年节约电极费用约60万元，电费约40万元',
    otherTarget: '提升LF精炼效率',
    personnelChange: '无变动',
    innovation: '采用AI弧流优化算法',
    energyAssess: '优化弧流后预计节电10%',
    applyDuration: '2026-08-15',
    suggestDuration: '2026-11-30',
    riskOpportunity: '风险：新系统调试需适应工艺；机遇：降低消耗成本',
    relatedOpinion: '建议先做一台LF炉试点',
    planAmount: 120,
    declareAmount: 140,
    suggestAmount: 130,
    costComposition: '智能控制器50万、传感器30万、执行机构20万、安装调试20万',
    removeUpdateCost: 3,
    conclusion: '智能调节改造效益明显，建议实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-03-18',
    attendees: '吴慧芳、谢建国、孙志强、林冬梅',
    meetingLocation: '炼钢事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
  {
    id: 'os-014',
    applyNo: 'LZ-2026-05214',
    planNo: 'PL-2026-01238',
    applyName: '板材事业部矫直机液压系统改造论证意见签署',
    projectType: '年修',
    isBenefit: true,
    createDate: '2026-03-25',
    status: '审批中',
    buildUnit: '板材事业部',
    handler: '林冬梅',
    applicant: '孙志强',
    currentSituation: '矫直机液压系统老化，故障频发，影响生产连续性',
    mainScheme: '更换液压系统关键部件，升级控制阀组',
    mainDevice: '液压泵、控制阀、油缸、管路',
    water: '不涉及',
    electricity: '优化后预计节电5%',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套液压油更换',
    techTarget: '液压系统可靠性提升至99%以上',
    benefitEffect: '减少停机损失约150万元/年',
    otherTarget: '提升设备可靠性',
    personnelChange: '无变动',
    innovation: '采用新型节能液压泵',
    energyAssess: '新泵效率更高，预计节电5%',
    applyDuration: '2026-09-01',
    suggestDuration: '2026-10-31',
    riskOpportunity: '风险：改造期间停机影响生产；机遇：提升设备可靠性',
    relatedOpinion: '建议与年修同步实施',
    planAmount: 90,
    declareAmount: 110,
    suggestAmount: 100,
    costComposition: '液压泵40万、阀组25万、油缸15万、管路及安装10万',
    removeUpdateCost: 2,
    conclusion: '液压系统改造必要，建议与年修同步实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-03-15',
    attendees: '林冬梅、孙志强、马小燕、何永强',
    meetingLocation: '板材事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
  {
    id: 'os-015',
    applyNo: 'LZ-2026-05215',
    planNo: 'PL-2026-01240',
    applyName: '能源动力事业部制氧机扩容改造论证意见签署',
    projectType: '大型新建',
    isBenefit: true,
    createDate: '2026-03-22',
    status: '草稿',
    buildUnit: '能源动力事业部',
    handler: '朱志华',
    applicant: '周国强',
    currentSituation: '现有制氧能力无法满足新增产能的氧气需求',
    mainScheme: '新增一套制氧机组，提升氧气供应能力',
    mainDevice: '空气压缩机、分子筛、膨胀机、分馏塔',
    water: '新增冷却水约800吨/小时',
    electricity: '新增用电量约8MW',
    gas: '不涉及',
    oxygen: '新增氧气产能约15000Nm³/h',
    otherAux: '需配套空分厂房及管网',
    techTarget: '新增氧气产能15000Nm³/h，满足新增产能需求',
    benefitEffect: '满足新增产能氧气需求，避免外购氧气',
    otherTarget: '提升能源自给率',
    personnelChange: '新增制氧运维人员8名',
    innovation: '采用新型高效分子筛技术',
    energyAssess: '新机组单位氧气能耗降低8%',
    applyDuration: '2026-06-01',
    suggestDuration: '2027-04-30',
    riskOpportunity: '风险：投资大，建设周期长；机遇：保障氧气供应安全',
    relatedOpinion: '建议分期实施',
    planAmount: 3200,
    declareAmount: 3500,
    suggestAmount: 3350,
    costComposition: '制氧机组2200万、厂房土建500万、管网300万、电气系统200万、安装调试200万',
    removeUpdateCost: 50,
    conclusion: '制氧扩容项目战略意义重大，建议尽快启动',
    orgUnit: '能源动力事业部',
    argumentDate: '',
    attendees: '',
    meetingLocation: '',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
  {
    id: 'os-016',
    applyNo: 'LZ-2026-05216',
    planNo: 'PL-2026-01242',
    applyName: '第二炼铁事业部烧结机环保升级论证意见签署',
    projectType: '技改',
    isBenefit: false,
    createDate: '2026-03-20',
    status: '待确认',
    buildUnit: '第二炼铁事业部',
    handler: '胡春兰',
    applicant: '黄秀英',
    currentSituation: '烧结机烟气排放指标接近限值，需要环保升级改造',
    mainScheme: '对烧结机烟气处理系统进行升级改造，增加脱硝设施',
    mainDevice: 'SCR脱硝装置、催化剂、烟气管道',
    water: '新增用水约30吨/月',
    electricity: '新增用电量约200kW',
    gas: '新增氨水消耗',
    oxygen: '不涉及',
    otherAux: '需配套氨水储存设施',
    techTarget: '烟气NOx排放≤50mg/m³，满足超低排放要求',
    benefitEffect: '消除环保风险，满足超低排放要求',
    otherTarget: '提升环保管理水平',
    personnelChange: '新增环保运维人员2名',
    innovation: '采用低温SCR脱硝技术',
    energyAssess: '新系统能耗优化，预计节电5%',
    applyDuration: '2026-08-01',
    suggestDuration: '2027-01-31',
    riskOpportunity: '风险：施工期间影响烧结生产；机遇：满足环保法规',
    relatedOpinion: '建议申请环保专项资金',
    planAmount: 680,
    declareAmount: 750,
    suggestAmount: 720,
    costComposition: '脱硝装置450万、催化剂120万、氨水系统60万、安装调试50万',
    removeUpdateCost: 20,
    conclusion: '环保升级项目必要且紧急，建议尽快实施',
    orgUnit: '安全环保处',
    argumentDate: '2026-03-10',
    attendees: '胡春兰、黄秀英、何永强、林冬梅',
    meetingLocation: '第二炼铁事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [{ name: '烧结机环保方案.pdf', size: 1650000, url: '#' }],
  },
  {
    id: 'os-017',
    applyNo: 'LZ-2026-05217',
    planNo: 'PL-2026-01245',
    applyName: '物流中心翻车机系统自动化改造论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-03-18',
    status: '已确认',
    buildUnit: '物流中心',
    handler: '马小燕',
    applicant: '孙志强',
    currentSituation: '翻车机人工操作效率低，安全风险高',
    mainScheme: '对翻车机系统进行自动化改造，实现无人化作业',
    mainDevice: '自动定位系统、自动摘钩装置、远程监控系统',
    water: '不涉及',
    electricity: '新增用电量约120kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套控制室及网络',
    techTarget: '实现翻车机无人化作业，作业效率提升30%',
    benefitEffect: '减少操作人员6名，提升卸车效率',
    otherTarget: '消除现场作业安全隐患',
    personnelChange: '减少翻车机操作工6名，新增中控操作员2名',
    innovation: '采用激光定位及视觉识别技术',
    energyAssess: '优化作业后预计节电6%',
    applyDuration: '2026-07-01',
    suggestDuration: '2026-10-31',
    riskOpportunity: '风险：新系统稳定性需验证；机遇：大幅提升效率和安全',
    relatedOpinion: '建议先做一台翻车机试点',
    planAmount: 280,
    declareAmount: 320,
    suggestAmount: 300,
    costComposition: '自动定位系统120万、摘钩装置80万、监控系统40万、安装调试40万',
    removeUpdateCost: 8,
    conclusion: '自动化改造项目效益显著，建议实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-03-08',
    attendees: '马小燕、孙志强、谢建国、吴慧芳',
    meetingLocation: '物流中心会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [{ name: '翻车机自动化方案.pdf', size: 1120000, url: '#' }],
  },
  {
    id: 'os-018',
    applyNo: 'LZ-2026-05218',
    planNo: 'PL-2026-01248',
    applyName: '特钢事业部连铸坯表面缺陷在线检测系统论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-03-15',
    status: '待签署',
    buildUnit: '特钢事业部',
    handler: '何永强',
    applicant: '胡春兰',
    currentSituation: '连铸坯表面缺陷依靠人工抽检，检测效率低，漏检率高',
    mainScheme: '引入在线表面缺陷检测系统，实现铸坯表面质量实时监控',
    mainDevice: '高清摄像头组、AI分析服务器、报警系统',
    water: '不涉及',
    electricity: '新增用电量约30kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套网络及服务器机房',
    techTarget: '缺陷检出率≥95%，实现在线实时检测',
    benefitEffect: '减少质量异议损失约100万元/年',
    otherTarget: '提升产品质量管控水平',
    personnelChange: '减少质检工2名',
    innovation: '采用深度学习AI缺陷识别算法',
    energyAssess: '系统能耗低，对整体能耗影响微小',
    applyDuration: '2026-08-01',
    suggestDuration: '2026-11-30',
    riskOpportunity: '风险：AI模型需大量样本训练；机遇：大幅提升检测效率',
    relatedOpinion: '建议先采集足够样本训练模型',
    planAmount: 150,
    declareAmount: 180,
    suggestAmount: 165,
    costComposition: '摄像头组60万、AI服务器40万、软件系统30万、安装调试20万',
    removeUpdateCost: 2,
    conclusion: '在线检测系统技术先进，建议实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-03-05',
    attendees: '何永强、胡春兰、林冬梅、马小燕',
    meetingLocation: '特钢事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
  {
    id: 'os-019',
    applyNo: 'LZ-2026-05219',
    planNo: 'PL-2026-01250',
    applyName: '炼钢事业部转炉副枪系统升级论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-03-12',
    status: '已签署',
    buildUnit: '炼钢事业部',
    handler: '谢建国',
    applicant: '何永强',
    currentSituation: '现有副枪系统测量精度不足，影响转炉终点控制',
    mainScheme: '升级副枪系统，提升测量精度和响应速度',
    mainDevice: '新型副枪探头、信号处理系统、控制软件',
    water: '不涉及',
    electricity: '新增用电量约20kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套控制柜升级',
    techTarget: '测量精度提升20%，响应时间缩短30%',
    benefitEffect: '减少补吹次数，提升转炉作业率约3%',
    otherTarget: '提升转炉终点控制精度',
    personnelChange: '无变动',
    innovation: '采用新型高精度传感器技术',
    energyAssess: '减少补吹次数后预计节氧5%',
    applyDuration: '2026-07-15',
    suggestDuration: '2026-10-31',
    riskOpportunity: '风险：新系统需调试适应；机遇：提升转炉作业效率',
    relatedOpinion: '建议与年修同步实施',
    planAmount: 110,
    declareAmount: 130,
    suggestAmount: 120,
    costComposition: '副枪系统60万、信号处理系统30万、控制软件15万、安装调试5万',
    removeUpdateCost: 1,
    conclusion: '副枪升级项目技术成熟，建议实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-03-02',
    attendees: '谢建国、何永强、林冬梅、马小燕',
    meetingLocation: '炼钢事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [{ name: '副枪升级方案.pdf', size: 760000, url: '#' }],
  },
  {
    id: 'os-020',
    applyNo: 'LZ-2026-05220',
    planNo: 'PL-2026-01255',
    applyName: '板材事业部平整机延伸率自动控制系统论证意见签署',
    projectType: '技改',
    isBenefit: true,
    createDate: '2026-03-10',
    status: '待呈核',
    buildUnit: '板材事业部',
    handler: '孙志强',
    applicant: '林冬梅',
    currentSituation: '平整机延伸率控制依赖人工经验，产品质量波动大',
    mainScheme: '引入延伸率自动控制系统，根据产品要求自动调节',
    mainDevice: '延伸率测量装置、自动调节控制器、执行机构',
    water: '不涉及',
    electricity: '新增用电量约25kW',
    gas: '不涉及',
    oxygen: '不涉及',
    otherAux: '需配套控制柜升级',
    techTarget: '延伸率控制精度±0.3%，产品合格率提升至99%',
    benefitEffect: '减少质量异议损失约60万元/年',
    otherTarget: '提升产品质量稳定性',
    personnelChange: '无变动',
    innovation: '采用在线延伸率实时反馈控制技术',
    energyAssess: '优化控制后预计节电3%',
    applyDuration: '2026-08-15',
    suggestDuration: '2026-11-30',
    riskOpportunity: '风险：新系统需调试；机遇：提升产品质量',
    relatedOpinion: '建议先做一台平整机试点',
    planAmount: 85,
    declareAmount: 100,
    suggestAmount: 92,
    costComposition: '测量装置40万、控制器25万、执行机构15万、安装调试5万',
    removeUpdateCost: 1,
    conclusion: '自动控制系统技术成熟，建议实施',
    orgUnit: '设备管理部',
    argumentDate: '2026-02-28',
    attendees: '孙志强、林冬梅、谢建国、吴慧芳',
    meetingLocation: '板材事业部会议室',
    committeeDate: '',
    committeeAttendees: '',
    committeeStatus: '',
    attachments: [],
  },
];